import styled from 'styled-components';
import { ThemeColours } from '../../../../../styles/ThemeColours';
import {
  LineHeight,
  FontSize,
  FontWeight,
  FONT_STACK,
  STANDARD_TRANSITION,
  STANDARD_SHRINK,
  Breakpoint,
} from '../../../../../styles/constants';
import { HIDE_SCROLL_BAR } from '../../../../../styles/mixins';
import { propSwitch } from '../../../../../util/propSwitch';
import { NewBackArrowIcon } from '../../../SearchHeader.styles';

export const SuggestionHeader = styled.div`
  height: auto;
  margin-top: 16px;

  ${Breakpoint.SMALL} {
    margin-top: unset;
  }
`;

export const SingleViewSuggestionHeader = styled.div`
  height: auto;
  margin-bottom: 0px;

  ${Breakpoint.SMALL} {
    margin-top: unset;
  }
`;

export const SuggestionHeaderLabel = styled.p<{ error?: boolean }>`
  ${FONT_STACK}
  color: ${propSwitch('error', ThemeColours.accent500, ThemeColours.mono700)};
  font-size: ${FontSize.BODY_REGULAR};
  font-weight: ${FontWeight.REGULAR};
  line-height: ${LineHeight.BODY_REGULAR};
  margin: 0px;
  padding-bottom: 16px;
`;

export const SuggestionCategoriesContainer = styled.div`
  column-gap: 32px;
  display: block;
  grid-template-columns: repeat(auto-fit, minmax(311px, 1fr));
  overflow-y: auto;
  padding-bottom: 150px;
  transition: all 0.75s ease;
  width: 100%;

  ${Breakpoint.SMALL} {
    display: grid;
    padding-bottom: unset;
  }
`;

export const CategoryView = styled.div`
  padding: 0;
`;

export const SearchFooter = styled.div`
  padding-bottom: 100px;
`;

export const CategoryLabel = styled.div`
  ${FONT_STACK}
  color: ${ThemeColours.mono900};
  font-size: ${FontSize.LARGE};
  font-weight: ${FontWeight.HEADING_1};
  line-height: ${LineHeight.HEADING_3_SMALL};
  margin-bottom: 6px;
`;

// As short as needed
export const SuggestionLayoutView = styled.div`
  animation: moveToRight 1s ease-in-out;
  animation-delay: 10ms;
  background-color: ${ThemeColours.white};
  display: flex;
  flex: 1;
  flex-direction: column;
  max-height: 100%;
  min-height: 300px;
  overflow-x: hidden;

  @keyframes moveToRight {
    0% {
      transform: translateX(0px);
    }
    100% {
      transform: translateX(500px);
    }
  }
`;

// Fixed size
export const ButtonBarContainer = styled.div`
  flex-grow: 0;
  min-height: 40px;
`;

// Expands to fill its content, but caps off and shows a scrollbar
export const ListContainer = styled.div`
  flex: 1;
  overflow-x: hidden;
  overflow-y: auto;
  padding-bottom: 0px;
  padding-right: 16px;

  ${Breakpoint.SMALL} {
    padding-right: unset;
  }
`;

export const BackToAll = styled.button`
  ${FONT_STACK}
  ${STANDARD_TRANSITION};
  ${HIDE_SCROLL_BAR};
  background-color: ${ThemeColours.white};
  border: none;
  color: ${ThemeColours.primary500};
  cursor: pointer;
  display: none;
  flex: 0 0 auto;
  font-size: ${FontSize.BODY_REGULAR};
  font-weight: ${FontWeight.HEADING_1};
  height: 24px;
  justify-content: center;
  &:active {
    transform: scale(${STANDARD_SHRINK});
  }
  padding: 0px;

  ${Breakpoint.SMALL} {
    display: flex;
  }
`;

export const StyledBackArrow = styled(NewBackArrowIcon)`
  color: ${ThemeColours.primary500};
  margin-inline-end: 8px;
`;
